export default {
  vdOverlayClicked: 'vd-overlay:clicked',
}
